import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Products = () => {
  return (
    <section id="products" className="bg-slate-950 text-white overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="p-10 md:p-20 lg:p-32 xl:p-40 flex flex-col justify-center bg-slate-50 lg:order-2"
        >
          <div className="relative">
            <div className="absolute -top-20 -left-20 w-64 h-64 bg-[#62b2c9]/10 rounded-full blur-3xl"></div>
            <h2 className="text-sm font-black text-slate-900 uppercase tracking-[0.3em] mb-6">Innovative Løsninger</h2>
            <h3 className="text-5xl md:text-6xl font-black mb-8 leading-tight uppercase tracking-tighter text-slate-900">
              Fremtidens <span className="text-slate-900">Energy Storage</span> Systemer
            </h3>
            <p className="text-xl text-slate-600 mb-10 leading-relaxed font-medium">
              Vores systemer er bygget på verdensledende battericeller og intelligent styringsteknologi. 
              Vi tilbyder alt fra container-løsninger til industrielle batterianlæg.
            </p>
            <ul className="space-y-8 mb-16">
              {[
                "Højeste sikkerhedsstandarder",
                "Intelligent BMS (Battery Management System)",
                "Skalerbare modulære løsninger",
                "Lang levetid og høj effektivitet"
              ].map((item, i) => (
                <motion.li 
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 + 0.3 }}
                  className="flex items-center gap-4 text-slate-700 font-bold uppercase tracking-tight text-sm"
                >
                  <div className="w-6 h-[2px] bg-[#62b2c9]"></div>
                  {item}
                </motion.li>
              ))}
            </ul>
            <Link to="/produkter" className="inline-block bg-[#62b2c9] hover:bg-[#62b2c9]/90 text-white px-10 py-5 rounded-none font-black uppercase tracking-widest transition-all">
              produkter
            </Link>
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative h-64 lg:h-auto lg:order-1"
        >
          <img 
            src="/images/CNTE-C&I-STAR H-MAX 220kw 440kwh DATA-1.jpg" 
            alt="CNTE C&I STAR H-MAX" 
            className="w-full h-full object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Products;
